import React, { useEffect } from "react";
import Header from "../components/main/header";
// import { UNSAFE_NavigationContext } from "react-router-dom";
import Notification from "@3gaam/shared/components/general/notification";
import { useSelector } from "react-redux";

const Main = ({ children }) => {
  const selectorData = useSelector((state) => ({
    error: state?.general?.errorReducer,
  }));

  useEffect(() => {
    if (selectorData?.error?.data) {
      showErrorMessage(selectorData?.error);
    }
  }, [selectorData]);

  const showErrorMessage = (error) => {
    let errorsData = error?.data,
      errorsMessages = errorsData?.errors,
      errorsMessagesText = "";
    if (errorsMessages) {
      for (let err in errorsMessages)
        errorsMessagesText += `${errorsMessages[err]} \n`;
    }
    const allErrorsMessagesText = errorsMessages
      ? errorsMessagesText
      : errorsData?.title || errorsData?.Title;
    Notification({
      type: "danger",
      message: allErrorsMessagesText || "لطفا چند لحظه بعد دوباره تلاش کنید",
    });
  };

  return (
    <div className="capp-main-container">
      <main className="main-content">
        <Header title={"test"} />
        {children}
      </main>
    </div>
  );
};

export default React.memo(Main);
